import api from './api';

export interface InvestmentOpportunity {
  id: string;
  type: string;
  network: string;
  platform: string;
  apy: number;
  categories: string[];
  logo_url: string;
  network_logo_url: string;
  investment_steps: {
    title: string;
    description: string;
    url: string;
    order: number;
  }[];
  link: string;
  created_at?: string;
  updated_at?: string;
  created_by?: string;
  updated_by?: string;
}

export const investmentService = {
  async getBestOpportunities(): Promise<InvestmentOpportunity[]> {
    const { data } = await api.get<InvestmentOpportunity[]>('/api/v1/investment/best-opportunities');
    return data;
  },
};
